var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlovakia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0234C24.8366 32.0234 32 24.86 32 16.0234C32 7.18688 24.8366 0.0234375 16 0.0234375C7.16344 0.0234375 0 7.18688 0 16.0234C0 24.86 7.16344 32.0234 16 32.0234Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0234C24.8365 32.0234 32 24.8599 32 16.0234C32 14.0663 31.648 12.1915 31.0048 10.4582H0.995188C0.352063 12.1915 0 14.0663 0 16.0234C0 24.8599 7.1635 32.0234 16 32.0234Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 32.0235C22.8796 32.0235 28.7443 27.6815 31.005 21.5887H0.995361C3.25605 27.6815 9.12074 32.0235 16.0002 32.0235Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.13721 9.06712V17.0487C4.13721 21.589 10.0685 22.9802 10.0685 22.9802C10.0685 22.9802 15.9998 21.589 15.9998 17.0487V9.06712H4.13721Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.52881 9.06712V17.0488C5.52881 17.5818 5.64718 18.0851 5.88168 18.5571H14.2559C14.4904 18.0852 14.6087 17.5818 14.6087 17.0488V9.06712H5.52881Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8511 14.6321H10.7642V13.2408H12.1555V11.8495H10.7642V10.4582H9.37289V11.8495H7.98164V13.2408H9.37289V14.6321H7.28589V16.0234H9.37289V17.4147H10.7642V16.0234H12.8511V14.6321Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77904 20.4992C8.6756 21.0626 9.59672 21.3898 10.0683 21.5353C10.5398 21.3898 11.461 21.0626 12.3575 20.4992C13.2617 19.931 13.8955 19.2811 14.2553 18.557C13.8584 18.2762 13.3741 18.1106 12.8509 18.1106C12.6604 18.1106 12.4753 18.1331 12.2974 18.1746C11.9203 17.3178 11.0644 16.7193 10.0683 16.7193C9.07229 16.7193 8.21628 17.3178 7.83928 18.1746C7.66135 18.1331 7.47622 18.1106 7.28579 18.1106C6.7626 18.1106 6.27829 18.2762 5.88135 18.557C6.24104 19.281 6.87485 19.9309 7.77904 20.4992Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0234375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlovakia);
export default __webpack_public_path__ + "static/media/slovakia.44c0fe40.svg";
export { ForwardRef as ReactComponent };